import React, { Component, Fragment } from 'react';
import './Home.module.scss';

import {lessonsData} from 'utilities/lessons';

//Import components
import LessonBlock from 'components/UI/LessonBlock/LessonBlock';
import PageTitle from 'components/UI/PageTitle/PageTitle';
import Button from 'components/UI/Button/Button';
import SideNavigation from 'components/UI/SideNavigation/SideNavigation';
import TopNavigation from 'components/UI/TopNavigation/TopNavigation';
import ModalContainer from 'components/UI/ModalContainer';
import ContentContainer from 'components/UI/ModalContainer/components/ContentContainer/ContentContainer';
import PageWrapper from 'components/UI/PageWrapper/PageWrapper';
import BackgroundPolygons from 'components/UI/BackgroundPolygons/BackgroundPolygons';

class Home extends Component {

    constructor() {
        super();

        this.state = {
            modalOpen: false,
            modalLessonId: 0
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleLessonClick = this.handleLessonClick.bind(this);
        this.lessonblockLimit = this.lessonblockLimit.bind(this);
    }

    openModal() {
        this.setState({
            modalOpen: true
        });
    }

    closeModal() {
        this.setState({
            modalOpen: false
        });
    }

    handleLessonClick(lessonId) {
        this.setState({
            modalOpen: true,
            modalLessonId: lessonId
        });
    }

    //scroll to top
    componentDidUpdate() {
        window.scrollTo(0,0);
    }

    componentDidMount() {
        window.scrollTo(0,0);
    }

    // mediaquerry lessonblock
    lessonblockLimit(){
        if (window.innerWidth > 1920) {
            return 4
        }
        else if (window.innerWidth < 750) {
            return 1
        }
        else if (window.innerWidth < 1400) {
            return 2
        } 
        else if (window.innerWidth < 1920) {
            return 3
        }
        
        
    }

    render() {

        return (

            <Fragment>
                <TopNavigation/>
                <SideNavigation/>
                <PageWrapper>
                    <div styleName='index-header'>
                        <div styleName='index-header-content'>
                            <img styleName='index-header-image' src='/images/svg/goto_logo.svg'></img>
                            <Button style={{margin: 'auto', backgroundColor:'$blue',color:'white',padding:'8px 16px 5px 16px',borderRadius:'100px',width: 'fit-content',   fontSize:'12px',fontWeight:'400',borderWidth:'0px',display:'block',transition:'0.1s'}}link='/programmeertalen' styleName='index-button' text='GoTo software dowload'/>
                        </div>
                    </div>
                    <div styleName='main'>
                    <BackgroundPolygons></BackgroundPolygons>
                        <div styleName='maxwidth'>
                            <div styleName='fullwidthblock'>
                                <div styleName='left'>
                                    <h3>
                                        Welkom op het GoTo platform
                                    </h3>
                                    <p>
                                    Dit is het nieuwe GoTo platform. Op dit platform vind je een vernieuwd aanbod aan lessen. Daarnaast is er een inspiratie waar leuke (voorbeeld)projecten op staan die je zelf kunt aanpassen of gewoon mee kunt spelen. 
                                    <br></br>
                                    <br></br>
                                    Om te beginnen met je GoTo ga je eerst naar downloads pagina om de software te downloaden waar de GoTo mee werkt. Als je over de software vragen hebt of ergens anders niet uitkomt kun je het antwoord waarschijnlijk vinden op de Vragen pagina.
                                    
                                
                                    </p> 
                                    <Button link='/lessen' text='Ga naar de lessen!'/>
                                </div>

                                    <img styleName='right' src='/images/svg/goto_gedraaid.svg'></img>

                            </div>

                            <div styleName='lesson-wrapper'>
                                {
                                    lessonsData.map((lesson, index) =>
                                        index < this.lessonblockLimit() && <LessonBlock index={index} lesson={lesson} level={lesson.level} handleClick={this.handleLessonClick} />
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </PageWrapper>
                <ModalContainer open={this.state.modalOpen} closeModal={this.closeModal} >
                { this.state.modalOpen && 
                    <Fragment>
                        <ContentContainer
                            closeModal={this.closeModal}
                            lessonId={this.state.modalLessonId}
                        
                        />
                    </Fragment>
                }
                </ModalContainer>
            </Fragment>
        );
    }
}

export default Home;


// WEBPACK FOOTER //
// ./resources/assets/screens/Home/Home.jsx